module.exports = "https://portperrypedals.ca/_res/img/willowtree.f595f4d.png";